/**
 * @author Owais Liaquat Ali
 * @datetime June, 24th 2023
 * @description: This class is for date time parsed.
 */
import { Pipe, PipeTransform } from '@angular/core';
import { ParsedActivityDateTimePipe } from '../parsed-activity-date-time/parsed-activity-date-time.pipe';
import { UniqueChangeDetectorCharacterPipe } from '../unique-change-detector-character/unique-change-detector-character.pipe';

@Pipe({
  name: 'mediator',
})
export class MediatorPipe implements PipeTransform {
  constructor(
    private parsedActivityDateTimePipe: ParsedActivityDateTimePipe,
    private uniqueChangeDetectorCharacterPipe: UniqueChangeDetectorCharacterPipe
  ) {}

  transform(
    value: string,
    parseFormat: `t` | `MMM dd` | `MMM yyyy`,
    isYesterday: boolean,
    currentIndex: number
  ): boolean {
    const parsedValue = this.parsedActivityDateTimePipe.transform(
      value,
      parseFormat,
      isYesterday
    );
    return this.uniqueChangeDetectorCharacterPipe.transform(
      parsedValue,
      currentIndex
    );
  }
}
